/**
 * Типы schema.org, которыми магазины размечают то, что можно подарить.
 *
 * Список общий на оба разбора. Поймано на корпусе: Буквоед размечает книгу
 * типом Book, а не Product, и разбор в браузере проходил мимо разметки вовсе —
 * название бралось из OpenGraph вместе с рекламным хвостом «📕 купить
 * в Буквоеде», а цена из встроенного состояния. Книги, игры и фильмы — это
 * половина вишлиста, и терять их разметку из-за буквы в типе нельзя.
 *
 * Разделено на две части намеренно.
 *
 * ТИПЫ_ВЕЩЕЙ — то, что само по себе является предметом страницы. По ним можно
 * и данные брать, и считать, сколько товаров на странице.
 *
 * ТОВАРНЫЕ_ТИПЫ шире: сюда добавлены Offer, Service и CreativeWork. Считать
 * по ним товары нельзя — предложений на странице бывает много, и они не про
 * разные вещи, — но данные из них брать можно, когда ничего лучше нет.
 */
export const ТИПЫ_ВЕЩЕЙ: ReadonlySet<string> = new Set([
  'product',
  'productmodel',
  'productgroup',
  'individualproduct',
  'book',
  'movie',
  'musicalbum',
  'videogame',
  'softwareapplication',
  'vehicle',
  'car',
  'apartment',
  'house',
  'residence',
  'singlefamilyresidence',
  'accommodation',
  'realestatelisting',
  'hotel',
  'touristtrip',
  'course',
]);

export const ТОВАРНЫЕ_ТИПЫ: ReadonlySet<string> = new Set([
  ...ТИПЫ_ВЕЩЕЙ,
  'offer',
  'aggregateoffer',
  'event',
  'service',
  'creativework',
]);

/** Приводит @type к сравнимому виду: тип бывает и ссылкой на schema.org. */
export function именаТипов(тип: unknown): string[] {
  const список = Array.isArray(тип) ? тип : [тип];
  return список
    .filter((значение): значение is string => typeof значение === 'string')
    .map((значение) => значение.replace(/^https?:\/\/schema\.org\//i, '').trim().toLowerCase());
}

/** Размечена ли этим типом сама вещь — то, что человек кладёт в вишлист. */
export function этоТипВещи(тип: unknown): boolean {
  return именаТипов(тип).some((имя) => ТИПЫ_ВЕЩЕЙ.has(имя));
}
